import React, { Component } from 'react';
import axios from 'axios'

import withStyles from '@mui/styles/withStyles';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';

import EditIcon from '@mui/icons-material/Edit';
import PeopleIcon from '@mui/icons-material/People';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import Alert from '@mui/material/Alert';
import { AuthConsumer } from "../../context/AuthContext";

import styles from "../styles";
import PageHeader from "../helper/PageHeader";
import Loading from '../helper/Loading';
import Error from '../helper/Error';

class TrainingProviders extends Component {
    constructor(props) {

        super(props);
        this.token = sessionStorage.getItem('accessToken');

        this.state = {
            loading: false,
            providers: [],
            error: null,
            isDeleteDialogOpen: false,
            itemToDelete: '',
            provider: null
        }
    }

    handleDeleteDialogOpen = () => {
        this.setState({ isDeleteDialogOpen: true });
    };

    handleDeleteDialogClose = () => {
        this.setState({ isDeleteDialogOpen: false });
    };

    onNew = (event) => {
        this.props.history.push('/dashboard/trainingProvider/new/' + this.props.match.params.username);
    }

    onEdit = (event) => {
        let id = this.state.provider;
        this.props.history.push('/dashboard/trainingProvider/edit/' + id);
    }

    onManageMembers = (event) => {
        let id =  this.state.provider;
        this.props.history.push('/dashboard/trainingProvider/members/' + id);
    }

    onAddWorkshop = event => {
        let id =  this.state.provider;

        // passes trainingProvider id
        this.props.history.push({
            pathname: '/class',
            state: {
                trainingProvider: {
                    id,
                }
            }
        });
    }

    onManageClasses = event => {
        this.props.history.push('/dashboard/trainingProvider/manageClasses/' + this.state.provider);        
    }

    onProviderSelect = (event) => {
        sessionStorage.setItem('selectedProvider', event.target.value)
        this.setState({ 
            provider: event.target.value
        });
    }

    onDeleteGroup = (event) => {
        event.preventDefault();
        // let groupID = event.currentTarget.getAttribute('data-tag');
        this.handleDeleteDialogClose();
        let groupID = this.state.itemToDelete;
        this.setState({ itemToDelete: '' });

        let url = '/api/usergroup/' + groupID;
        axios(url, {
            method: 'DELETE',
            headers: {
                'Authorization': this.token
            }
        }).then(response => {
            if (response.status >= 400) {
                throw new Error(response.statusText);
            }

            this.refresh();
        }).catch(err => {
            this.setState({ error: err.message });
        });
    }

    hideError = () => {
        this.setState({ error: '' })
    }

    refresh() {
        /*process.env.REACT_APP_SERVER + */
        this.setState({ loading: true })
        let url = '/api/groupuser/group/' + this.props.match.params.username;
        axios(url, {
            method: 'GET'
        })
            .then(res => res.data)
            .then(result => {
                console.log(result.groups);
                let providers = []
                result.groups.forEach((e) => {
                    if (e.type === 'Training Provider') {
                        console.log(e);
                        providers.push({value: e.id, label: e.name, memberType: e.memberType});
                    }
                });

                console.log("this is providers", providers);

                let newName = sessionStorage.getItem('selectedTP')
                console.log("new TP name", newName)
                if(newName){
                    let searchedResult = providers.find(item=>
                        item.label === newName
                    )
                    if (searchedResult) {
                         console.log("this is the value", searchedResult.value)
                        sessionStorage.setItem('selectedProvider', searchedResult.value)
                    }
                   
                }
                let selectedProvider = sessionStorage.getItem('selectedProvider')
                console.log(selectedProvider)
                let provider = selectedProvider ? selectedProvider : providers.length > 0 ? providers[0].value : '';
                this.setState({
                    providers: providers,
                    provider: provider,
                    loading: false 
                });
            }).catch(error => {
                this.setState({ 
                    error: error.message,
                    loading: false
                });
            });
    }

    componentDidMount() {
        this.refresh();
    }

    componentWillUnmount() {
        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state,callback)=>{
            return;
        };
    }

    componentDidUpdate(prevProps) {
        // Typical usage (don't forget to compare props):
        if ((this.props.groups !== this.state.groups) && (this.props.groups !== undefined)) {
            this.setState({
                providers: this.props.groups
            })
        }
    }

    render() {
        const { classes } = this.props;

        if (this.state.error) {
            return <div>
                <br />
                <Alert severity="error" onClose={this.hideError}>{this.state.error}</Alert>
                <br />
            </div>
        }

        if (this.state.error !== null) return <Error />;

        if (this.state.loading) return <Loading />

        return (
            <div>
                <PageHeader
                    title={"For Training Providers"}
                />
                
                <Grid container justifyContent="space-around"  alignItems="center">

                    <Grid item xs={12} md={8} style={{ textAlign: "left", alignSelf: "flex-start" }}>
                        <p>A Training Provider is typically an organization or company location with at least one GI-BMP Certified Instructor that offers GI-BMP in-person or remote classes.  
                        </p>
                        <ul>
                            <li>Any Certified Instructor can create a Training Provider group and add others to help manage the GI-BMP classes for that site.</li>
                            <li>Any member of a Training Provider group can add or edit classes, members, and default settings.</li>
                            <li>Anyone with a GI-BMP login account can be added – members do not have to be a Certified Instructor.</li>
                        </ul>
                    </Grid>
                </Grid>
               
                <Grid container spacing={3}>
                    <Grid item xs={6} sm={6}>
                        {console.log('this.state.providers', this.state.providers)}
                        <TextField
                            id="provider"
                            name="provider"
                            className={[classes.textField].join(' ')}
                            onChange={this.onProviderSelect}
                            value={this.state.provider ? this.state.provider : '' }
                            defaultValue = ''
                            select
                            fullWidth
                            label=" Select Training Provider"
                            
                        >
                            {this.state.providers.map((option) => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                     <AuthConsumer>
                        {({ roles }) =>
                        (roles.isCertifiedInstructor) ? (
                            <Grid item>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="large"
                                    className={[].join(' ')}
                                    onClick={this.onNew}
                                    >
                                    Add training provider
                                </Button>
                            </Grid>
                        ) : <Grid/>
                        }
                    </AuthConsumer>
                    <AuthConsumer>
                        {({ roles }) =>
                        (roles.isInstructor || this.state.provider) ? (
                            <Grid item>
                               <Button 
                                variant="contained" 
                                size="large" color="primary" 
                                href='https://ffl.ifas.ufl.edu/gibmp-resources/'
                                >
                                Instructor Resources
                            </Button>
                            </Grid>
                        ) : <Grid/>
                        }
                    </AuthConsumer>
                </Grid>
                {(this.state.providers.length < 1) &&
                    <p>You are not a member of any Training Provider group. If you have a role in organizing GI-BMP training classes and believe you should have access to this page, please check with the lead GI-BMP Instructor for your organization, or contact your <a href='https://ffl.ifas.ufl.edu/ffl-and-you/gi-bmp-program/gi-bmp-contacts/#d.en.851702'>GI-BMP Regional Coordinator</a> for help.</p>
                }
                <br/>
                {(this.state.provider) &&
                <Grid container direction="row" justifyContent="space-between" alignItems="center">
                    <Button
                        variant="contained"
                        color="primary"
                        size="large"
                        className={[].join(' ')}
                        onClick={this.onManageMembers}
                        startIcon={<PeopleIcon />}
                        >
                        Training Provider Admin
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        size="large"
                        className={[].join(' ')}
                        onClick={this.onEdit}
                        startIcon={<EditIcon />}
                    >
                    Edit Defaults
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        size="large"
                        className={[].join(' ')}
                        onClick={this.onAddWorkshop}
                        startIcon={<AddCircleIcon />}
                    >
                        Add Class
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        size="large"
                        className={[].join(' ')}
                        onClick={this.onManageClasses}
                        startIcon={<FormatListBulletedIcon />}
                    >
                        Manage Classes
                    </Button>
                    
                </Grid>
                }
            </div>
        );
    }
}

export default withStyles(styles, { withTheme: true })(TrainingProviders);
